import PropTypes from 'prop-types'
import React, { useMemo } from 'react'

import { FILES, KUNUNU_WIDGET } from '@/config'
import { KUNUNU_WIDGET_LIST_TYPE } from '@/config/constants'

import Stars from './Stars'

const KununuStars = ({ score = 0, className, type = KUNUNU_WIDGET_LIST_TYPE }) => {
  const stars = useMemo(() => {
    const kununuStars = []
    for (let i = 0; i < 5; i++) {
      const value = (score - i).toFixed(1)
      if (value <= 0.2) {
        kununuStars.push({
          image: FILES.STAR_EMPTY_IMAGE,
          alt: 'empty star'
        })
      } else if (value >= 0.3 && value <= 0.7) {
        kununuStars.push({
          image: FILES.STAR_HALF_IMAGE,
          alt: 'half star'
        })
      } else {
        kununuStars.push({
          image: FILES.STAR_FULL_IMAGE,
          alt: 'full star'
        })
      }
    }
    return kununuStars
  }, [score])

  const {
    width: starWidth,
    height: starHeight
  } = KUNUNU_WIDGET[type].star

  return (<Stars className={className} stars={stars} starWidth={starWidth} starHeight={starHeight} />)
}

KununuStars.propTypes = {
  score: PropTypes.number,
  className: PropTypes.string,
  type: PropTypes.string
}

export default KununuStars
